import { z } from "zod";

export const brandColorsSchema = z.object({
	primary: z.string(),
	secondary: z.string(),
	splash: z.string(),
});

export const brandGoogleSchema = z.object({
	iosClientId: z.string(),
	iosReversedClientId: z.string(),
	androidClientId: z.string(),
	webClientId: z.string(),
});

export const brandExtraSchema = z
	.object({
		brandId: z.string(),
		appName: z.string(),
		communityId: z.string().optional(),
		communitySlug: z.string().optional(),
		colors: brandColorsSchema,
		google: brandGoogleSchema,
	})
	.passthrough();

export type BrandExtra = z.infer<typeof brandExtraSchema>;
